module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Ticket_black-f63eb3d84311eec7e69b70a6499814d9.svg";